import React from 'react';
import { Transition } from '@headlessui/react';
import PropTypes from 'prop-types';

export default function Modal({ show, title, onClose, children, footer }) {
  return (
    <Transition
      show={show}
      enter="transition-all ease-in duration-100"
      enterFrom="opacity-0"
      enterTo="opacity-100"
    >
      <div className="fixed inset-0 z-20 overflow-y-auto">
        <div className="flex items-end justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
          <div className="fixed inset-0">
            <div className="absolute inset-0 bg-gray-100 opacity-75"></div>
          </div>
          <span className="hidden sm:inline-block sm:align-middle sm:h-screen"></span>
          <div
            className="inline-block px-8 pt-5 pb-8 overflow-hidden text-left align-bottom bg-white rounded-lg shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full"
            role="dialog"
            aria-modal="true"
            aria-labelledby="modal-headline"
          >
            <h3 className="mb-3 font-bold">{title}</h3>
            <div
              className="absolute cursor-pointer top-3 right-3"
              onClick={onClose}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="w-6 h-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
            </div>
            {children}
            {footer}
          </div>
        </div>
      </div>
    </Transition>
  );
}

Modal.propTypes = {
  show: PropTypes.bool.isRequired,
  title: PropTypes.string,
  onClose: PropTypes.func,
  children: PropTypes.node,
  footer: PropTypes.node
};

Modal.defaultProps = {
  title: '',
  onClose: () => { },
  children: <></>,
  footer: <></>
};
